import { createFileRoute } from '@tanstack/react-router'
import { PopularDomains, ToolPage } from '@/components/tool-page/tool-page'
import { toolHead } from '@/components/tool-page/tool-head'
import { DnsTool, isRecordType } from '@/components/tool-page/dns-tool'
import { POPULAR_SITES } from '@/lib/popular-sites'
import { TOOLS } from '@/lib/tool-content'

const content = TOOLS['dns-lookup']

export const Route = createFileRoute('/_site/tools/dns-lookup')({
  component: DnsLookupPage,
  validateSearch: (search: Record<string, unknown>): { q?: string; type?: string } => ({
    q: typeof search.q === 'string' && search.q ? search.q : undefined,
    type: typeof search.type === 'string' && search.type ? search.type : undefined,
  }),
  head: () => toolHead(content),
})

function DnsLookupPage() {
  const { q, type } = Route.useSearch()
  const upper = type?.toUpperCase()
  return (
    <ToolPage content={content} extra={<PopularDomains toolPath="/tools/dns-lookup" heading="Look up the DNS records of a popular site" sites={POPULAR_SITES} />}>
      <DnsTool content={content} initialName={q ?? ''} initialType={isRecordType(upper) ? upper : 'A'} autoRun={!!q} />
    </ToolPage>
  )
}
